import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatTableContentType } from 'src/utils/table';

import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import RedirectLink from '@Components/RedirectLink';
import { generateRedirectUrlToLog } from '@Log/shared';
import { getServiceNamesByValues } from '@Utils/service';
import { useDashboardServicesStore } from '@Models/useDashboardServicesModel';
import { LogTypeEnum } from '@Types/log';

const QuishingContentType = (props: { data: any; day: string }) => {
  const { t } = useTranslation();
  const timeModel = useUtcOffsetStore();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '23%', grow: 2, align: 'left', tooltip: true },
    { width: '15%', grow: 1, align: 'right' },
    { width: '15%', grow: 1, align: 'left', tooltip: true },
  ];
  const header = [
    t('dashboard.chart.column.type'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.lastDetected'),
  ];

  const data = formatTableContentType(
    props.data?.quishingSource?.[props.day],
    ['key', 'total', 'last_detected'],
    t,
    timeModel.offset
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'mergedSecurityRiskName',
              values: ['VAN_QUISHING.UMXX', 'QUISHING'],
              type: 'match',
            },
            {
              field: 'extractUrlType',
              values: [row[0] as string].includes(
                t('common.contentType.QUISHING_IMAGE')
              )
                ? ['URL_EXTRACTED_TYPE_VIA_QR_EXTRACT']
                : ['URL_EXTRACTED_TYPE_VIA_QR_EXTRACT_PDF'],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    row[2],
  ]);

  return (
    <DashboardCard
      title={t('dashboard.chart.title.quishingDetectionsContentType.content')}
      iconContent={t(
        'dashboard.chart.title.quishingDetectionsContentType.tooltip'
      )}
    >
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
};

export default React.memo(QuishingContentType);
